import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/static/icons/magnifying_glass.svg'


const _hoisted_1 = { class: "decoration-placement" }
const _hoisted_2 = { class: "decoration-placement__title-and-zoom" }
const _hoisted_3 = { class: "decoration-placement__title" }
const _hoisted_4 = { class: "decoration-placement__container" }
const _hoisted_5 = { class: "decoration-zoom__modal" }
const _hoisted_6 = { class: "decoration-zoom__modal-title" }
const _hoisted_7 = { class: "decoration-zoom__modal-placement-container" }

import { ref, computed, inject } from 'vue';

import { injectionKeys as litiumKeys } from '@motillo/drapejs-litium';
import ModalContainer from "@/components/ModalContainer.vue";
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import DecorationCard from './DecorationCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationPlacement',
  props: {
  placements: {
    type: Array,
    required: true,
  },
  selected: {
    type: String,
    default: '',
  },
},
  emits: ['selected', 'selectedValue'],
  setup(__props, { emit: __emit }) {

const { websiteText } = useWebsiteTexts();
const emit = __emit;
const toLitiumMediaUrl = inject(litiumKeys.toLitiumMediaUrlKey, () => '');
const registerModal = inject('registerModal');
const unregisterModal = inject('unregisterModal');

const props = __props;

const mappedPlacements = computed(() => {
  return props.placements.map(p => {
    return {
      id: p.systemId,
      name: p.position.name || p.position.value,
      value: p.position.value,
      url: toLitiumMediaUrl(p.positionImageSystemId, { maxWidth: 359 }),
      area: p.printableArea || '',
    };
  });
});

const selectedPlacement = ref(props.selected);
const zoomModalOpen = ref(false);

function selectPlacement(id: string) {
  selectedPlacement.value = id;
  emit('selected', id);
}

function selectPlacementValue(value: string) {
  emit('selectedValue', value);
}

function openZoomModal() {
  registerModal('DecoratorRemove');
  zoomModalOpen.value = true;
}

function closeZoomModal() {
  zoomModalOpen.value = false;
  unregisterModal('DecoratorRemove');
}

function selectZoomedInPlacement(id: string) {
  selectPlacement(id);
  closeZoomModal();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(websiteText)('decoration__choose_placement').value), 1),
      _createElementVNode("div", {
        class: "decoration-placement__zoom",
        onClick: openZoomModal
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__zoom').value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappedPlacements.value, (placement) => {
        return (_openBlock(), _createBlock(DecorationCard, {
          key: placement.id,
          decoration: placement,
          selected: placement.id === selectedPlacement.value,
          onSelected: selectPlacement,
          onSelectedValue: selectPlacementValue
        }, null, 8, ["decoration", "selected"]))
      }), 128))
    ]),
    (zoomModalOpen.value)
      ? (_openBlock(), _createBlock(ModalContainer, {
          key: 0,
          "show-exit-button": true,
          position: "center",
          onCloseModal: closeZoomModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(websiteText)('decoration__choose_placement').value), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappedPlacements.value, (placement) => {
                  return (_openBlock(), _createBlock(DecorationCard, {
                    key: placement.id,
                    decoration: placement,
                    selected: placement.id === selectedPlacement.value,
                    onSelected: selectZoomedInPlacement,
                    onSelectedValue: selectPlacementValue
                  }, null, 8, ["decoration", "selected"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})